import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

function Services() {
  const navigate = useNavigate();

  return (
    <section className="services section" id="services">
      <div className="services-container">
        <h2 className="services-title">Nos <span className="services-highlight">services</span></h2>
        <p className="services-intro">
          Grâce à nos outils et stratégies basés sur l'IA, notre entreprise vous aide à créer une présence en 
          ligne puissante. Nous concevons des sites performants, des contenus optimisés et des identités 
          visuelles qui séduisent autant les moteurs de recherche que vos clients.
        </p>

        <div className="services-grid">
          <div className="service-card service-card-pink-left">
            <h3 className="service-card-title">Développement Web<br/>Intelligent</h3>
            <p className="service-card-text">
              Chez Viviworks.IA, le développement web devient plus qu'une simple création de site. C'est plutôt une expérience intelligente qui séduit. Grâce à l'intégration de l'IA, nous analysons vos besoins, anticipons les interactions et concevons des interfaces capables d'évoluer.
            </p>
          </div>

          <div className="service-card service-card-white-top">
            <h3 className="service-card-title">Design Graphique &<br/>Branding créatifs</h3>
            <p className="service-card-text">
              Notre approche du design graphique et du branding allie créativité humaine et intelligence artificielle pour concevoir des identités visuelles percutantes.
            </p>
            <p className="service-card-text">
              L'IA nous aide à analyser les tendances, les couleurs et les émotions pour créer des visuels cohérents, uniques et mémorables.
            </p>
            <button className="service-card-button" onClick={() => navigate('/design-graphique')}>En savoir plus</button>
          </div>

          <div className="service-card service-card-pink-bottom">
            <h3 className="service-card-title">Référencement & Rédaction<br/>SEO assistés par IA</h3>
            <p className="service-card-text">
              Nous ne rédigeons pas seulement des articles : nous concevons des contenus capables de propulser votre site en tête des résultats de recherche.
            </p>
            <p className="service-card-text">
              Avec l'IA, chaque mot est choisi pour séduire les algorithmes tout en captivant les visiteurs de votre site internet.
            </p>
            <button className="service-card-button" onClick={() => navigate('/referencement')}>En savoir plus</button>
          </div>
        </div>

        <div className="services-button-wrapper">
          <button className="services-button">Découvrez nos solutions IA</button>
        </div>
      </div>
    </section>
  );
}

export default Services;

